import { render, staticRenderFns } from "./SendRecord.vue?vue&type=template&id=a05c4394&scoped=true"
import script from "./SendRecord.vue?vue&type=script&lang=js"
export * from "./SendRecord.vue?vue&type=script&lang=js"
import style0 from "./SendRecord.vue?vue&type=style&index=0&id=a05c4394&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05c4394",
  null
  
)

export default component.exports